// Password validation criteria
export const passwordValidation = {
  minLength: (password: string) => password.length >= 10,
  maxLength: (password: string) => password.length <= 100,
  hasUpperCase: (password: string) => /[A-Z]/.test(password),
  hasLowerCase: (password: string) => /[a-z]/.test(password),
  hasNumber: (password: string) => /[0-9]/.test(password),
  hasSpecialChar: (password: string) => /[!@#$%^&*(),.?":{}|<>]/.test(password),
};
